<template>
	<div class="a-flex-rfsc a-ptb-12" >
		<div class="s-search-label a-flex-rfec" v-show="label">
			<span class="a-c-red a-fs-14" v-if="notnull">*</span>
			<span>{{label}}</span>
		</div>
		<div class="a-flex-cfsfs a-ml-10">
			<el-cascader 
                v-model="values"
                ref="cascader" 
                :class="large?'s-large-input':'s-nomarl-input'" 
                placeholder="请选择省市区" 
                :props="{ 
                    checkStrictly: true ,
                    value: 'adcode',
                    label: 'name',
                    children: 'districts',
                }" 
                :options="options" 
                clearable
				@change="handleChange">
			</el-cascader>
		</div>

	</div>

</template>

<script>
	/**
	 * 省市区选择
	 */
	import {
		regionData,
        regionDataPlus,
        provinceAndCityData,
		CodeToText,
		TextToCode
	} from 'element-china-area-data'
    import axios from 'axios';
	export default {
		props: {
			province: {
				required: false,
				type: String,
			},
			city: {
				required: false,
				type: String,
			},
			area: {
				required: false,
				type: String,
			},
			placeholder: {
				type: String,
				default: '请输入详细地址'
			},
			label: {
				type: String
			},
			/**
			 * 是否必填
			 */
			notnull: {
				type: Boolean,
				default: false,
				required: false,
			},
			/**
			 * 是否为较长的输入框
			 */
			large: {
				type: Boolean,
				required: false,
				default: false
			},
            /**
			 * 是否为省市二级联动
			 */
            provinceAndCity: {
                type: Boolean,
                default: false
            }
		},
		data() {
			return {
				options: this.provinceAndCity?provinceAndCityData:regionData,
				selectedOptions: ["","",""],
                values: [],
				provinceChange:false,
				cityChange:false,
				areaChange:false,
			}
		},
		computed:{
			codeChange(){
				return{
					provinceChange:this.provinceChange,
					cityChange:this.cityChange,
					areaChange:this.areaChange
				}
			},
            selectInfo () {
                return (this.province?this.province:'') + (this.city?this.city:'') + (this.area?this.area:'')
            }
		},
		watch:{
			province:{
				handler(val,oldval){
					if(val!=oldval || !oldval){
						this.provinceChange=true
					}
				}
			},
			city:{
				handler(val,oldval){
					if(val!=oldval || !oldval){
                        this.cityChange=true
					}
				}
			},
			area:{
				handler(val,oldval){
					if(val!=oldval || !oldval){
                        this.areaChange=true
					}
				}
			},
			codeChange:{
				handler(val){
					if(this.provinceChange || this.cityChange || this.areaChange){
						this.$set(this,'selectedOptions',[this.province,this.city,this.area])
						this.provinceChange = false
						this.cityChange = false
						this.areaChange = false
					}
				}
			},
            selectInfo: {
                handler (val) {
                    if(!val) {
                        this.$refs.cascader.$refs.panel.clearCheckedNodes()
                        this.$refs.cascader.$refs.panel.activePath = []
                    }
                }
            }
			
		},
        created () {
            this.getCity()
        },
		mounted() {
            setInterval(function() {
                document.querySelectorAll(".el-cascader-node__label").forEach(el => {
                    el.onclick = function() {
                        if (this.previousElementSibling) this.previousElementSibling.click();
                    };
                });
            }, 1000)
		},
		methods: {
            getCity () {
                const url = 'https://restapi.amap.com/v3/config/district?subdistrict=3&key=43883cb5ebc5cdc66c6e2ce050c69e3e'
                axios.get(url).then(res => {
                    // 递归处理数据，移除没有子节点的空children，避免产生空白下拉菜单
                    this.options = this.formatTreeData(res.data.districts[0].districts)
                    console.log(this.options,11111);
                })
            },
             // 3. 递归处理函数，核心是处理空数组
            formatTreeData (data) {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].districts.length < 1) {
                        data[i].districts = undefined
                    } else {
                        this.formatTreeData(data[i].districts)
                    }
                }
                return data
            },
			handleChange(value) {
				this.$emit("update:province",value[0])
				this.$emit("update:city",value[1])
				this.$emit("update:area",value[2])
			}
		}

	}
</script>
